import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getStrandUnits } from "../lib/requestFunctions";

export function useStrandUnits(
    selectedClass: string | undefined,
    selectedSubject: string | undefined,
    selectedStrand: string | undefined,
) {
    const [selectedStrandUnit, setSelectedStrandUnit] = useState<string | undefined>(
        undefined,
    );

    const {
        status: strandUnitStatus,
        fetchStatus: strandUnitFetchStatus,
        data: strandUnits,
    } = useQuery({
        queryKey: ["strandUnits", selectedClass, selectedSubject, selectedStrand],
        queryFn: () =>
            getStrandUnits(
                selectedClass ? [parseInt(selectedClass)] : [],
                selectedSubject ? [parseInt(selectedSubject)] : [],
                selectedStrand ? [parseInt(selectedStrand)] : [],
            ),
        enabled: !!selectedClass && !!selectedSubject && !!selectedStrand,
    });

    useEffect(() => {
        setSelectedStrandUnit(undefined);
    }, [selectedClass, selectedSubject, selectedStrand]);

    //@ts-ignore
    const strandUnitsData = strandUnits?.data?.map((strandUnit) => ({
        key: strandUnit.id,
        text: strandUnit.name,
    })) ?? [];

    return {
        selectedStrandUnit,
        setSelectedStrandUnit,
        strandUnitsData,
        strandUnitStatus,
        strandUnitFetchStatus,
        strandUnitsLoading: strandUnitStatus === 'pending' && strandUnitFetchStatus === 'fetching',
        strandUnitsError: strandUnitStatus === 'error',
    };
}